import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { GepjarmuService } from '../gepjarmu.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';
import { fmt, fmtMax, gjLapNyomtat, hibaSzoveg, huDatum } from '../utnyilvantartas/gj-nyomtatas';

/*  GÉPJÁRMŰ – KIKÜLDETÉSI RENDELVÉNY ÉS KÖLTSÉGELSZÁMOLÁS (magángépkocsi hivatalos célú használata).
 *  A rendelvény az útnyilvántartásból készül (Kulcs-Autó mintájára): a saját autó + kiküldött + időszak üzleti
 *  útjai kerülnek rá; a számítás hónaponként a NAV-áron (korrekciókkal) + az általános normaköltség × km +
 *  egyéb igazolt költség − előleg. Nyomtatás után lezárul (a rendelvény és az útjai sem módosíthatók), és
 *  átadható a Bérbe (155-ös jogcím). Szerkesztési zár: gepjarmu_rendelveny. Backend: backend/gepjarmu-ut.js. */
@Component({
  selector: 'app-gj-kikuldetes',
  templateUrl: './kikuldetes.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../gepjarmu-shared.scss'],
})
export class GjKikuldetesComponent implements OnInit, OnDestroy {
  readonly egyebFajtak = [{ kod: 'szallas', nev: 'Szállás' }, { kod: 'etkezes', nev: 'Étkezés / napidíj' }, { kod: 'parkolas', nev: 'Parkolás, útdíj' }, { kod: 'egyeb', nev: 'Egyéb' }];
  torzs: any = { jarmuvek: [], soforok: [] };
  lista: any[] = [];
  szerk: any = null;
  elonezet: any = null;
  dolgozik = false;
  zar: SzerkZar | null = null;
  private zarKor = 0;
  private sub?: Subscription;
  private kulcs = '';
  private szamolIdozito: any = null;
  fmt = fmt; fmtMax = fmtMax; huDatum = huDatum;

  constructor(public gj: GepjarmuService, private http: HttpClient, private toast: ToastController, private alert: AlertController, private szerkZar: SzerkZarService) {}
  get u() { return this.gj.aktiv.ugyfelId; }
  get ev() { return this.gj.aktiv.ev; }
  get ir() { return this.gj.ir; }
  get maganJarmuvek(): any[] { return this.torzs.jarmuvek.filter((j: any) => j.magan); }
  get osszesen(): number { return this.lista.reduce((s, r) => s + (Number(r.fizetendo_ft) || 0), 0); }

  async ngOnInit() {
    await this.gj.init();
    this.sub = this.gj.aktiv$.subscribe((a) => { const k = `${a.ugyfelId}|${a.ev}`; if (k !== this.kulcs) { const ceg = !this.kulcs.startsWith(`${a.ugyfelId}|`); this.kulcs = k; this.betolt(ceg); } });
  }
  ngOnDestroy() { this.sub?.unsubscribe(); this.zarElenged(); clearTimeout(this.szamolIdozito); }

  async betolt(torzsIs = true) {
    if (!this.u) { this.lista = []; return; }
    try {
      if (torzsIs || !this.torzs.jarmuvek.length) this.torzs = await this.gj.get(`ut:/torzs/${this.u}`);
      this.lista = await this.gj.get(`ut:/rendelvenyek/${this.u}?ev=${this.ev}`);
    } catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült betölteni a rendelvényeket.')); }
  }
  allapot(r: any): { a: string; nev: string } {
    if (r.ber_atadva) return { a: 'kesz', nev: 'a Bérben' };
    if (r.nyomtatva) return { a: 'kiallitva', nev: 'lezárva' };
    return { a: 'piszkozat', nev: 'tervezet' };
  }

  /* ── szerkesztő ── */
  uj() {
    this.zarElenged();
    const j = this.maganJarmuvek.find((x) => +x.aktiv) || this.maganJarmuvek[0];
    const most = new Date();
    const ev = this.ev, ho = ev === most.getFullYear() ? most.getMonth() + 1 : 1;
    const tol = `${ev}-${String(ho).padStart(2, '0')}-01`, ig = `${ev}-${String(ho).padStart(2, '0')}-${String(new Date(ev, ho, 0).getDate()).padStart(2, '0')}`;
    this.szerk = { id: null, jarmu_id: j?.id || '', sofor_id: j?.alap_sofor_id || '', tol, ig, cel: '', egyeb: [], eloleg: 0 };
    this.szamol();
  }
  async nyit(r: any) {
    this.zarElenged();
    this.szerkBetolt(r);
    if (this.ir && !r.nyomtatva && !r.ber_atadva) {
      const kor = this.zarKor;
      const z = await this.szerkZar.foglal('gepjarmu', 'gepjarmu_rendelveny', r.id, { ujratolt: () => this.ujratolt(r.id) });
      if (kor !== this.zarKor || this.szerk?.id !== r.id) { z?.felenged(); return; }
      this.zar = z;
    }
  }
  private szerkBetolt(r: any) {
    this.szerk = { id: r.id, sorszam: r.sorszam, jarmu_id: r.jarmu_id, sofor_id: r.sofor_id, tol: r.tol, ig: r.ig, cel: r.cel || '', egyeb: (r.reszletek?.egyeb || []).map((e: any) => ({ ...e })),
      eloleg: r.eloleg_ft || 0, nyomtatva: r.nyomtatva, ber_atadva: r.ber_atadva, mentett: r };
    this.elonezet = { ...r, utak: [], ...(r.reszletek || {}) };
    this.szamol();
  }
  private async ujratolt(id: string) {
    await this.betolt(false);
    const r = this.lista.find((x) => x.id === id);
    if (r && this.szerk?.id === id) this.szerkBetolt(r);
  }
  private zarElenged() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  bezar() { this.szerk = null; this.elonezet = null; this.zarElenged(); }
  get lezart(): boolean { return !!(this.szerk?.nyomtatva || this.szerk?.ber_atadva); }
  get irhato(): boolean { return this.ir && !this.lezart && !(this.zar && !this.zar.irhato); }
  egyebUj() { this.szerk.egyeb.push({ fajta: 'parkolas', megnevezes: 'Parkolás, útdíj', bizonylat: '', osszeg: null }); }
  egyebTorol(i: number) { this.szerk.egyeb.splice(i, 1); this.szamolKesve(); }
  egyebFajta(e: any) { const f = this.egyebFajtak.find((x) => x.kod === e.fajta); if (f && (!e.megnevezes || this.egyebFajtak.some((x) => x.nev === e.megnevezes))) e.megnevezes = f.nev; }
  szamolKesve() { clearTimeout(this.szamolIdozito); this.szamolIdozito = setTimeout(() => this.szamol(), 450); }
  /*  Előnézet: a kiszolgáló számolja (ugyanazzal a kóddal, mint a mentés) – a már mentett rendelvény
   *  saját útjai is választhatók maradnak. A lezártnál a mentett számítás látszik. */
  async szamol() {
    const s = this.szerk;
    if (!s || !s.jarmu_id || !s.sofor_id || !s.tol || !s.ig || this.lezart) return;
    try {
      this.elonezet = await this.gj.post(`ut:/rendelveny/${this.u}`, { ...this.torzsAdat(), elonezet: true, rendelveny_id: s.id });
    } catch (e: any) { this.elonezet = { hiba: hibaSzoveg(e, 'Nem sikerült a számítás.') }; }
  }
  private torzsAdat() {
    const s = this.szerk;
    return { jarmu_id: s.jarmu_id, sofor_id: s.sofor_id, tol: s.tol, ig: s.ig, cel: s.cel, eloleg: s.eloleg || 0,
      egyeb: s.egyeb.filter((e: any) => e.megnevezes || e.osszeg).map((e: any) => ({ fajta: e.fajta, megnevezes: e.megnevezes, bizonylat: e.bizonylat, osszeg: e.osszeg || 0 })) };
  }
  //  A számítás sorai: a kiszolgáló előnézetének részletei, ill. a mentett rendelvényé.
  get elonezetUtak(): any[] { return this.elonezet?.reszletek?.utak || this.elonezet?.utak || []; }
  get elonezetHonapok(): any[] { return this.elonezet?.reszletek?.honapok || this.elonezet?.honapok || []; }
  jarmuValt() { const j = this.torzs.jarmuvek.find((x: any) => x.id === this.szerk.jarmu_id); if (j?.alap_sofor_id && !this.szerk.sofor_id) this.szerk.sofor_id = j.alap_sofor_id; this.szamol(); }
  get mentheto(): boolean { return this.irhato && !!this.elonezet && !this.elonezet.hiba && this.elonezet.km > 0 && !(this.elonezet.hianyzo_ar?.length); }
  async ment() {
    if (!this.mentheto) return;
    this.dolgozik = true;
    try {
      const r: any = this.szerk.id ? await this.gj.put(`ut:/rendelveny/${this.szerk.id}`, this.torzsAdat()) : await this.gj.post(`ut:/rendelveny/${this.u}`, this.torzsAdat());
      this.ok(this.szerk.id ? 'A rendelvény mentve.' : `Rendelvény létrehozva: ${r.sorszam}.`);
      this.bezar(); await this.betolt(false);
    } catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült menteni.')); }
    finally { this.dolgozik = false; }
  }
  async torol() {
    if (!this.irhato || !this.szerk?.id) return;
    const a = await this.alert.create({ header: 'Rendelvény törlése', message: `${this.szerk.sorszam} – az útjai felszabadulnak (az útnyilvántartásban megmaradnak).`,
      buttons: [{ text: 'Mégsem', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: () => this.torolVeg() }] });
    await a.present();
  }
  private async torolVeg() {
    try { await this.gj.del(`ut:/rendelveny/${this.szerk.id}`); this.ok('A rendelvény törölve.'); this.bezar(); await this.betolt(false); }
    catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült törölni.')); }
  }

  /* ── nyomtatás és lezárás ── */
  async nyomtat(r: any) {
    try { await gjLapNyomtat(this.http, `/rendelveny/${r.id}/nyomtat`); }
    catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült a nyomtatás.')); return; }
    if (r.nyomtatva || !this.ir) return;
    const a = await this.alert.create({ header: 'Lezárod a rendelvényt?', message: `Ha a(z) ${r.sorszam} rendelvény kinyomtatása sikerült, zárd le: utána sem a rendelvény, sem az útjai nem módosíthatók, és átadható a Bérbe.`,
      buttons: [{ text: 'Még nem', role: 'cancel' }, { text: 'Lezárás', handler: () => this.lezar(r) }] });
    await a.present();
  }
  private async lezar(r: any) {
    try { await this.gj.post(`ut:/rendelveny/${r.id}/nyomtatva`); this.ok(`${r.sorszam} lezárva.`); if (this.szerk?.id === r.id) this.bezar(); await this.betolt(false); }
    catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült lezárni.')); }
  }

  /* ── Bér-átadás ── */
  private hoOf(r: any) { return { ev: Number(String(r.ig).slice(0, 4)), ho: Number(String(r.ig).slice(5, 7)) }; }
  async berAtad(r: any) {
    const { ev, ho } = this.hoOf(r);
    this.dolgozik = true;
    try {
      const v: any = await this.gj.post(`ut:/ber-atadas/${this.u}`, { ev, ho, rendelveny_idk: [r.id], munkaba: false });
      this.ok(`${r.sorszam} átadva a Bérbe (${ev}. ${String(ho).padStart(2, '0')}. hónap, ${fmt(r.fizetendo_ft)} Ft).`);
      if (v.figyelmeztetes?.length) this.figy(v.figyelmeztetes.join('\n'));
      await this.betolt(false);
    } catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült az átadás.')); }
    finally { this.dolgozik = false; }
  }
  async berVisszavon(r: any) {
    const { ev, ho } = this.hoOf(r);
    const a = await this.alert.create({ header: 'Bér-átadás visszavonása', message: `A Bérből törlődik a(z) ${r.sorszam} térítése (${fmt(r.fizetendo_ft)} Ft).`,
      buttons: [{ text: 'Mégsem', role: 'cancel' }, { text: 'Visszavonás', role: 'destructive', handler: async () => {
        try {
          const l: any = await this.gj.get(`ut:/ber-atadasok/${this.u}?ev=${ev}&ho=${ho}`);
          const at = (l.atadasok || []).find((x: any) => x.fajta === 'kikuldetes' && x.forras_id === r.id && !x.visszavonva);
          if (!at) { this.hiba('Az átadás nem található.'); return; }
          await this.gj.del(`ut:/ber-atadas/${at.id}`); this.ok('Az átadás visszavonva.'); await this.betolt(false);
        } catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült visszavonni.')); }
      } }] });
    await a.present();
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 3000, color: 'success' })).present(); }
  private async figy(m: string) { (await this.toast.create({ message: m, duration: 6500, color: 'warning' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 5200, color: 'danger' })).present(); }
}
